(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hd-deal-pdp"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hd-deal-price')) {
  customElements.define('hd-deal-price', class extends HTMLElement {
    connectedCallback() {
      this.form = document.forms[this.getAttribute('form')];
      this.onVariant = event => this.querySelectorAll('[data-hd-variant]').forEach(offer => {
        offer.hidden = offer.dataset.hdVariant !== String(event.detail?.variant?.id);
      });
      this.form?.addEventListener('variant:change', this.onVariant);
    }
    disconnectedCallback() { this.form?.removeEventListener('variant:change', this.onVariant); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hd-lazy-chat"] && !Shopify.designMode) return;
  try {
    const launcher = document.querySelector('#hd-chat-launcher');
const trigger = launcher?.querySelector('[data-hd-chat]');
trigger?.addEventListener('click', () => {
  trigger.disabled = true;
  trigger.setAttribute('aria-busy', 'true');
  trigger.querySelector('span').textContent = trigger.dataset.loading;
  const fail = () => {
    trigger.removeAttribute('aria-busy');
    trigger.querySelector('span').textContent = trigger.dataset.unavailable;
    launcher.querySelector('a').hidden = false;
  };
  const timeout = setTimeout(fail, 20000);
  const script = document.createElement('script');
  script.id = 'ze-snippet';
  script.src = 'https://static.zdassets.com/ekr/snippet.js?key=c9a43f99-1099-4fa2-a986-38235c9a2f70';
  script.async = true;
  script.onerror = () => { clearTimeout(timeout); fail(); };
  script.onload = () => {
    if (typeof window.zE !== 'function') { clearTimeout(timeout); fail(); return; }
    window.zE('messenger:on', 'open', () => {
      clearTimeout(timeout);
      launcher.hidden = true;
    });
    window.zE('messenger', 'open');
  };
  document.body.appendChild(script);
}, { once: true });
  } catch(e) { console.error(e); }
})();

})();
